import { EventEmitter, Injectable } from "@angular/core";
import { Messaging, getToken, onMessage } from "@angular/fire/messaging";

@Injectable({
  providedIn: "root",
})
export class FirebaseService {
  private WebDeviceToken: string | null = null;

  public WebMessageSignal: EventEmitter<string> = new EventEmitter();

  constructor(private msg: Messaging) {}

  public requestPermission(): void {
    Notification.requestPermission().then(
      (notificationPermissions: NotificationPermission) => {
        if (notificationPermissions === "granted") {
          console.log("Granted");
          getToken(this.msg).then((token) => (this.WebDeviceToken = token));
          onMessage(this.msg, (message) => {
            console.log(message);
            this.WebMessageSignal.emit(
              message.notification?.title + ": " + message.notification?.body,
            );
          });
        }
        if (notificationPermissions === "denied") {
          console.log("Denied");
        }
      },
    );
  }
  public getToken(): string | null {
    console.log("Get Token:", this.WebDeviceToken);
    return this.WebDeviceToken;
  }
}
